// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2k5_n","actionsCol":"EnrolledClinics_actionsCol__3REqc"};